import React from "react";
import { formatEUR0 } from "@/lib/format";
import { CoachStat, MINT, RISK_OPTIONS } from "./shared";

// Pannello "Coach investimenti": profilo di rischio + liquidità investibile + statistiche.
// Presentazionale: stato e azioni restano nel parent (InvestmentsSheet).
export const CoachPanel = ({ coach, riskBusy, onChangeRisk }) => {
  if (coach === null) {
    return (
      <div className="mb-4 h-44 animate-pulse rounded-[12px] border border-white/[0.06] bg-[#0D0D14]" data-testid="coach-loading" />
    );
  }
  return (
    <div
      className="mb-4 rounded-[12px] border bg-[#0D0D14] p-4"
      style={{ borderColor: `${MINT}33`, boxShadow: `0 0 0 1px ${MINT}14` }}
      data-testid="invest-coach"
    >
      <div className="flex items-center justify-between">
        <p className="caps-tag flex items-center gap-1.5" style={{ color: MINT, opacity: 0.9 }}>
          <span aria-hidden>◎</span> Coach investimenti
        </p>
        {riskBusy && (
          <span className="caps-tag flex items-center gap-1.5 text-white/40" data-testid="coach-updating">
            <span className="liqo-dot-pulse h-1 w-1 bg-[#5EEAD4]" />
            Aggiorno…
          </span>
        )}
      </div>

      {/* selettore profilo di rischio */}
      <p className="caps-tag mb-1.5 mt-3 text-white/40">Profilo di rischio</p>
      <div className="flex gap-2" data-testid="risk-profile-selector">
        {RISK_OPTIONS.map((opt) => {
          const active = coach.risk_profile === opt.id;
          return (
            <button
              key={opt.id}
              onClick={() => onChangeRisk(opt.id)}
              disabled={riskBusy}
              data-testid={`risk-option-${opt.id}`}
              aria-pressed={active}
              className="mono flex-1 rounded-[8px] border py-2.5 text-[11px] font-medium uppercase tracking-[0.1em] transition-colors active:scale-[0.98] disabled:opacity-60"
              style={
                active
                  ? { borderColor: `${MINT}66`, color: MINT, background: `${MINT}12` }
                  : { borderColor: "rgba(255,255,255,0.1)", color: "rgba(255,255,255,0.5)" }
              }
            >
              {opt.label}
            </button>
          );
        })}
      </div>

      {/* liquidità investibile */}
      {coach.eligible ? (
        <div className="mt-4">
          <p className="caps-tag text-white/40">Liquidità investibile</p>
          <p
            className="mono mt-1 text-[30px] font-light leading-none tracking-[-1px] tabular"
            style={{ color: MINT }}
            data-testid="coach-investable"
          >
            {formatEUR0(coach.investable)}
          </p>
        </div>
      ) : (
        <p className="mt-4 text-[12px] font-light leading-[1.55] text-white/45" data-testid="coach-not-eligible">
          Per ora non hai liquidità in eccesso da investire: prima copri le tasse stimate
          ({formatEUR0(coach.tax_reserved)}) e il fondo emergenza ({formatEUR0(coach.emergency_fund)}).
        </p>
      )}

      {/* mini statistiche */}
      <div className="mt-4 grid grid-cols-2 gap-2" data-testid="coach-stats">
        <CoachStat label="Surplus / mese" value={formatEUR0(coach.monthly_surplus)} testid="coach-surplus" />
        <CoachStat label={`PAC ${coach.risk_label}`} value={`${formatEUR0(coach.pac_suggested)}/m`} testid="coach-pac" />
        <CoachStat
          label="Fondo emergenza"
          value={formatEUR0(coach.emergency_fund)}
          sub={`${coach.buffer_months} mesi di spese`}
          testid="coach-buffer"
        />
        <CoachStat label="Tasse accantonate" value={formatEUR0(coach.tax_reserved)} testid="coach-tax" />
      </div>

      {/* allocazione ipotetica */}
      <p className="mt-3 text-[12px] font-light leading-[1.55] text-white/50" data-testid="coach-allocation">
        Ipotesi {coach.risk_label}: {coach.allocation?.azionario}% ETF azionario globale ·{" "}
        {coach.allocation?.obbligazionario}% obbligazionario.
      </p>

      <p className="mono mt-3 text-[10px] leading-4 tracking-[0.03em] text-white/30" data-testid="coach-disclaimer">
        {coach.disclaimer}
      </p>
    </div>
  );
};
